export default "__VITE_ASSET__Ah1M6Q7p__"